import React from "react";
import ChrInfoPopover from "../../generic/Form/Basic/ChrInfoPopover";
import ChrLink from "../../generic/Utils/ChrLink.jsx";
import { eventTracker, getEventDetails } from "../../generic/Utils/eventTracker.js";
import ChrAlert from "../../generic/PageUI/Basic/Metric/ChrAlert.jsx";

/*
props = {
  value: <number>,
  theme: <'neutral'> # optional
  title: <string>,
  subtitle: <string>,
  result: <string>
}
*/

export const metricCardThemes = {
  NEUTRAL: "neutral"
}

const MetricCard = props => {
  const {
    value,
    theme = metricCardThemes.NEUTRAL,
    title,
    subtitle,
    result,
    resultUrl,
    helpText,
    url,
    className,
    alert = {}
  } = props;
  const {eventName, payload} = getEventDetails(props.eventDetails);

  const urlHandler = (targetUrl) => {
    targetUrl && window.open(targetUrl);
  }

  const clickHandler = (url) => {
    urlHandler(url);
    eventTracker(eventName, payload);
  }

  return(
    <div className= { `d-flex flex-row custom-padding-0-85 flex-gap-10 cui-border-gray border-radius-0-5-important ${className}` }>
      {
        (typeof(value) !== "undefined") && <div className={ `p-xs px-3 border-radius-0-25 cui-widget-${theme}-bg cui-widget-${theme}-text` }>
          <span className="cui-management-report-temp-metric-value font-600 cui-management-report-temp-metric-submetric-link">
            <ChrLink noHref onClick={ () => clickHandler(url) } isLinkOnClick={ !!url }>
              {value}
            </ChrLink>
          </span>
        </div>
      }
      <div className="d-flex flex-column justify-content-around mr-auto">
        <div className="cui-management-report-temp-card-metric-title">
          <div className="d-flex" >
            { title }
            <ChrAlert {...alert} containerLocator="#cjs-management-report-v2" className="pl-2"/>
            { helpText && <ChrInfoPopover
              html
              content={ helpText }
              delay={500}
              boundary="body"
              placement="auto"
              container="#cjs-management-report-v2"
              additionalIconClass="px-2 text-info"
              trigger="click hover"
            />
            }
          </div>
        </div>
        {
          subtitle && <div className="mr-auto">
            { subtitle }
          </div>
        }
      </div>
      {
        result && <div
          className={ `align-self-center btn btn-primary btn-sm btn-rounded-5 ${!resultUrl && "cui-unclickable-element"}` }
          onClick={ () => clickHandler(resultUrl) }
        >
          <div className="cui-management-report-temp-card-metric-action">
            {result}
          </div>
        </div>
      }
    </div>
  )
};

export default MetricCard;